import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const Preloader = ({ onComplete }: { onComplete: () => void }) => {
    const [animationComplete, setAnimationComplete] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setAnimationComplete(true);
            // Fire onComplete immediately so unblur starts while preloader fades
            onComplete();
        }, 700);
        return () => clearTimeout(timer);
    }, [onComplete]);

    return (
        <motion.div
            className="fixed inset-0 z-[9999] flex items-center justify-center bg-white overflow-hidden"
            initial={{ opacity: 1 }}
            animate={{
                opacity: animationComplete ? 0 : 1,
            }}
            transition={{
                duration: 0.5,
                ease: [0.76, 0, 0.24, 1],
            }}
        >
            <div className="relative flex items-center justify-center font-syne font-bold text-4xl md:text-9xl tracking-tighter text-blue-600 px-4 md:px-0">
                {/* DECK */}
                <motion.span
                    initial={{ y: 40, opacity: 0 }}
                    animate={{
                        y: animationComplete ? -30 : 0,
                        opacity: animationComplete ? 0 : 1
                    }}
                    transition={{ duration: 0.6, ease: "backOut" }}
                >
                    DECK
                </motion.span>

                {/* WALE */}
                <motion.span
                    initial={{ y: 40, opacity: 0 }}
                    animate={{
                        y: animationComplete ? -30 : 0,
                        opacity: animationComplete ? 0 : 1
                    }}
                    transition={{ duration: 0.6, ease: "backOut", delay: 0.1 }}
                >
                    WALE
                </motion.span>
            </div>
        </motion.div>
    );
};

export default Preloader;
